export default "__VITE_ASSET__BGV6IRDb__"